<template>
    <p style="text-align: right">
        <a-button @click="getPoints">
            <RedoOutlined/>
        </a-button>
    </p>
    <a-table
            size="small" :data-source="dataSource" :columns="columns" :loading="loadingAdmin"
            :pagination="{
                showTotal: (total) => '共 ' + total + ' 人'
            }"
    >
        <template #filterDropdown="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }">
            <div style="padding: 8px">
                <a-input
                        ref="searchInput"
                        :placeholder="`搜索 ${column.title}`"
                        :value="selectedKeys[0]"
                        style="width: 188px; margin-bottom: 8px; display: block"
                        @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                        @pressEnter="handleSearch(selectedKeys, confirm, column.dataIndex)"
                />
                <a-button
                        type="primary"
                        size="small"
                        style="width: 90px; margin-right: 8px"
                        @click="handleSearch(selectedKeys, confirm, column.dataIndex)"
                >
                    <template #icon><SearchOutlined /></template>
                    确认
                </a-button>
                <a-button size="small" style="width: 90px" @click="handleReset(clearFilters)">
                    重置
                </a-button>
            </div>
        </template>

        <template #points="{ record }">
                    <span>
                        <a-typography-text :type="record.points > 0? 'success': 'danger'">
                            {{record.points}}
                        </a-typography-text>
                      </span>
        </template>
        <template #charge="{ record }">
            <a-button shape="circle" @click="()=>handleCharge(record)" type="primary" ghost size="small">
                <template #icon>
                    <PlusOutlined/>
                </template>
            </a-button>
        </template>
    </a-table>
    <a-modal
            v-model:visible="visible" :title="'给会员[ '+ activeRecord?.account + ' ]充值'" @ok="handleOk"
            ok-text="确认"
            cancel-text="取消"
    >
        <a-divider/>
        <p>当前积分：{{activeRecord?.points}}</p>
        <a-form-item label="充值">
            <a-input-number id="inputNumber" v-model:value="points" :min="1" :step="100">
            </a-input-number>
        </a-form-item>
        <a-divider/>
        <p><span style="color: red">*</span> 注："上传"每次消耗100积分，"对话"每次消耗10积分</p>
    </a-modal>
</template>
<script setup>
    import {PlusOutlined, SearchOutlined, RedoOutlined} from '@ant-design/icons-vue';
    import {onMounted, ref} from 'vue';
    import {get_biogpt_admin_points, post_biogpt_admin_points} from "../../utils/bioinfo.api";
    import {jy_tip} from "../../utils/vue.tool";
    import {compare} from "../../utils/request";
    let dataSource = ref([]);
    let loadingAdmin = ref(true);
    let visible = ref(false);
    let activeRecord = ref(undefined);
    let state = ref({
        searchText: '',
        searchedColumn: ''
    });
    let points = ref(200);
    // 【account】用户名【points】积分值【add_datetime】创建时间【update_datetime】更新时间  【充值】（调接口）
    let columns = [
        {
            title: '用户', dataIndex: 'account',
            slots: { title: 'user', filterDropdown: 'filterDropdown', },
            onFilter: (value, record) =>
                record.account.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: compare('account')
        },
        {title: '积分', dataIndex: 'points', slots: { customRender: 'points' }, sorter: compare('points')},
        {title: '充值', dataIndex: 'charge', slots: { customRender: 'charge' },},
    ];
    onMounted(()=>{
        getPoints();
    });
    const getPoints = ()=>{
        loadingAdmin.value = true;
        get_biogpt_admin_points((res)=>{
            let {data, message} = res;
            loadingAdmin.value = false;
            if(data){
                dataSource.value = data;
            }
            else {
                jy_tip('获取积分变更记录失败：' + message);
            }
        })
    };

    const handleCharge = (record)=>{
        activeRecord.value = record;
        visible.value = true;
    };
    const handleOk = () => {
        let {account} = activeRecord.value;
        post_biogpt_admin_points({user_name: account, points: points.value}, (res)=>{
            let {message} = res;
            jy_tip(message, message);
            getPoints();
            visible.value = false;
        })
    };
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        state.value.searchText = selectedKeys[0];
        state.value.searchedColumn = dataIndex;
    };

    const handleReset = clearFilters => {
        clearFilters();
        state.value.searchText = '';
    };
</script>
<style>


</style>